import { createAction } from '@reduxjs/toolkit';
import { UserRoles } from '../../types';

export const changeUserAuditLogAction = createAction<string>('users/GET_AUDIT_LOG');

export const changeUserRoleAction = createAction<UserRoles>('users/CHANGE_ROLE');
